<!--  -->
<template>
    <div class="user_msg">
        <div class="user">
            <div class="left_img">
                <img v-if="!user.isLogin || !user.logourl" :src="require('@/common/images/special/user.png')" alt="">
                <img v-else :src="user.logourl" alt="">
            </div>
            <div class="right_btn">
                <p class="tips" v-if="!user.isLogin">欢迎来到资鲸课堂</p>
                <p class="tips" v-else>{{user.nickname}}</p>
                <div class="btn" v-if="!user.isLogin">
                    <el-button class="login" @click="goLogin">登录</el-button>
                    <el-button class="sign" @click="goSign">注册</el-button>
                </div>
                <div class="btn" v-else>
                    <el-button class="login" @click="goClockIn">打卡</el-button>
                    <el-button class="sign" @click="quitLogin">退出</el-button>
                </div>
            </div>
        </div>
        <div class="action">
            <div class="hear_record" @click="hearRecord">
                <div class="icon"></div>
                <div class="action_name">听课记录</div>
            </div>
            <div class="do_exam_record" @click="doExamRecord">
                <div class="icon"></div>
                <div class="action_name">做题记录</div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    data() {
        return {

        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        goClockIn() {
            if (this.user.isLogin) {
                this.$emit('openClockIn')
            } else {
                this.setLoginPop(true)
            }
            // console.log('打卡')
        },
        quitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this.$message.success('退出成功！')
        },
        // 听课记录
        hearRecord() {
            this.$router.push({name: 'ClassScheduleCard'})
        },
        // 做题记录
        doExamRecord() {
            this.$router.push({
                name: 'StartTopic',
                query: {
                    active: 4
                }
            })
        },
        // 去登录
        goLogin() {
            this.setLoginPop(true)
            this.$parent.$parent.$refs.logAndReg.loginPopType = 1
        },
        // 去注册
        goSign() {
            this.setLoginPop(true)
            this.$parent.$parent.$refs.logAndReg.loginPopType = 2
        },
        ...mapActions([
            'setLoginPop',
            'setUser'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .user_msg {
        // padding: 20px 20px 12px;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid #EEEEEE;
        height: 140px;
        box-sizing: border-box;
        .user {
            padding: 20px;
            display: flex;
            align-items: center;
            .left_img {
                margin-right: 12px;
                img {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
            }
            .right_btn {
                .tips {
                    font-size: 14px;
                    line-height: 20px;
                }
                .btn {
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    .el-button {
                        width: 52px;
                        height: 20px;
                        border-radius: 10px;
                        line-height: 18px;
                        padding: 0;
                        font-size: 12px;
                    }
                    .login {
                        margin-right: 10px;
                        background: linear-gradient(180deg, #74CDFF 0%, #409EFF 100%);
                        color: #fff;
                        border: none;
                    }
                    .sign {
                        border-color: #409EFF;
                        color: #409EFF;
                    }
                }
            }
        }
        .action {
            display: flex;
            align-items: center;
            padding: 10px 0;
            box-sizing: border-box;
            background: #FAFAFA;
            &>div {
                height: 20px;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .icon {
                    width: 14px;
                    height: 14px;
                    background-size: 100%;
                    margin-right: 4px;
                }
                .action_name {
                    font-size: 12px;
                    // &:hover {
                    //     color: #409EFF;
                    // }
                }
            }
            .hear_record {
                border-right: 1px solid #E5E5E5;
                .icon {
                    background-image: url('../../../../common/images/special/hear_record.png');
                }
                &:hover .icon {
                    background-image: url('../../../../common/images/special/hear_record_active.png');
                }
                &:hover .action_name {
                    color: #409EFF;
                }
            }
            .do_exam_record {
                .icon {
                    background-image: url('../../../../common/images/special/do_exam_record.png');
                }
                &:hover .icon {
                    background-image: url('../../../../common/images/special/do_exam_record_active.png');
                }
                &:hover .action_name {
                    color: #409EFF;
                }
            }
        }
    }
</style>